export const filter = {
    id: "",
    detail: "",
    search: "",
    created_at: "",
    updated_at: "",
};
